export const GET_OFFERS = 'GET_OFFERS';
export const GET_OFFER = 'GET_OFFER';
export const GET_OFFERS_SUCCESS = 'GET_OFFERS_SUCCESS';
export const GET_OFFER_SUCCESS = 'GET_OFFER_SUCCESS';
export const GET_HOT_OFFERS = 'GET_HOT_OFFERS';
export const GET_HOT_OFFERS_SUCCESS = 'GET_HOT_OFFERS_SUCCESS';
export const GET_HOT_OFFER = 'GET_HOT_OFFER';
export const GET_HOT_OFFER_SUCCESS = 'GET_HOT_OFFER_SUCCESS';
